// magic for isometric env var
const getEnvVar = <T = string>(key: string, transformFn?: (v: string) => T) => {
  if (typeof window !== "undefined") {
    return (window as any).travello_env[key] as T;
  }
  if (transformFn && process.env[key]) {
    return transformFn(process.env[key]!);
  }
  return process.env[key];
};

export const REPO_VERSION = getEnvVar("REPO_VERSION");
export const REPO_REVISION = getEnvVar("REPO_REVISION");
export const REACT_APP_API_URL = getEnvVar("REACT_APP_API_URL") ?? "";
export const REACT_APP_FB_ID = getEnvVar("REACT_APP_FB_ID");
export const REACT_APP_FB_REDIRECT_URI = getEnvVar("REACT_APP_FB_REDIRECT_URI");
export const REACT_APP_GOOGLE_ID = getEnvVar("REACT_APP_GOOGLE_ID");
export const GOOGLE_OAUTH2_KEY = getEnvVar("GOOGLE_OAUTH2_KEY") ?? "";
export const AMPLITUDE_API_KEY = getEnvVar("AMPLITUDE_API_KEY") ?? "";
export const BRANCH_API_KEY = getEnvVar("BRANCH_API_KEY");
export const BUGSNAG_API_KEY = getEnvVar("BUGSNAG_API_KEY") ?? "";
export const BUGSNAG_RELEASE_STAGE = getEnvVar("BUGSNAG_RELEASE_STAGE");
export const REST_URL = getEnvVar("REST_URL");
export const GRAPHQL_URL = getEnvVar("GRAPHQL_URL");
export const FACEBOOK_PIXEL_ID = getEnvVar("FACEBOOK_PIXEL_ID");
export const GTM_ID = getEnvVar("GTM_ID");
export const FIREBASE_CONFIG = getEnvVar("FIREBASE_CONFIG", JSON.parse);
export const REMOTE_CONFIG =
  getEnvVar("REMOTE_CONFIG", JSON.parse) ?? ({} as object);
export const REDIS_URL = getEnvVar("REDIS_URL");
export const SERVER_GRPC_URL = getEnvVar("SERVER_GRPC_URL") ?? "";
export const SERVER_GRAPHQL_URL = getEnvVar("SERVER_GRAPHQL_URL") ?? "";
export const PARTNER_ID = getEnvVar("PARTNER_ID");
export const EXTRA_HEAD_TAGS = getEnvVar("EXTRA_HEAD_TAGS") ?? "";
export const EXTRA_BODY_TAGS = getEnvVar("EXTRA_BODY_TAGS") ?? "";
export const EXTRA_FOOTER_TAGS = getEnvVar("EXTRA_FOOTER_TAGS") ?? "";
export const BASE_TITLE =
  getEnvVar("BASE_TITLE") ?? "Travello - Connect & Explore";
export const OG_DESCRIPTION =
  getEnvVar("OG_DESCRIPTION") ??
  "Connect with travellers nearby, Share your travel adventures, book your next tour or experience on Travello";
export const OG_IMAGE = getEnvVar("OG_IMAGE");
export const API_KEY = getEnvVar("API_KEY");
